export default {
	"0": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Mensaje del servidor"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Missatge del servidor"
		}
	},
	"1": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Se ha producido un error general"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "S'ha produït un error general"
		}
	},
	"2": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "Se ha perdido la sesión",
			"aviso": "Por favor vuelva a intentarlo."
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "S'ha perdut la sessió"
		}
	},
	"3": {
		"categoria": 'important',
		"es": {
			"titulo": "Acceso denegado",
			"cuerpo": "El usuario con el que está tratando de ingresar no tiene permisos de acceso. En caso de duda puede contactar con <a href='mailto:c.profesionales@ufv.es'>c.profesionales@ufv.es</a>",
			"to": '/login'
		},
		"ca": {
			"titulo": "Accés denegat",
			"cuerpo": "L'usuari o contrasenya proporcionats no són vàlids Revisau les dades, feu servir la funcionalitat de recuperar contrasenya o contactau amb nosaltres en cas que tingueu dubtes"
		}
	},
	"4": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se ha encontrado la oferta"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No hem trobat l'oferta"
		}
	},
	"6": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a empleo"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'oferta s'adreça a feina"
		}
	},
	"7": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a prácticas"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'oferta s'adreça a pràctiques"
		}
	},
	"8": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El dato existía previamente"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "La dada ja existia"
		}
	},
	"9": {
		"categoria": 'medium',
		"es": {
			"titulo": "Acceso denegado",
			"cuerpo": "Lo sentimos, el usuario que has indicado o pertenece a una empresa que no está validada en el sistema, o ha sido bloqueado. Por favor contacta con nosotros si si tienes cualquier consulta."
		},
		"ca": {
			"titulo": "Accés denegat",
			"cuerpo": "Ens sap greu, l'usuari que heu indicat o pertany a una empresa que no està validada al sistema o ha estat blocat Per favor, contactau amb nosaltres si teniu cap consulta"
		}
	},
	"10": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya es candidato/a a la oferta"
		},
		"es": {
			"titulo": "Error",
			"cuerpo": "Ja sou candidat a l'oferta"
		}
	},
	"11": {
		"categoria": 'medium',
		"es": {
			"titulo": "Atención",
			"cuerpo": "Falta documentación necesaria"
		},
		"ca": {
			"titulo": "Atención",
			"cuerpo": "Falta documentació necessària"
		}
	},
	"12": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Se ha producido un error enviando el email"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "S'ha produït un error enviant el correu"
		}
	},
	"13": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a otra titulación perfil.",
			"to": '/'
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'oferta s'adreça a una altra titulació perfil",
			"to": '/'
		},
	},
	"14": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede pasar al estado seleccionado desde el actual" 
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No podeu passar a l'estat seleccionat des de l'actual"
		}
	},
	"15": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Faltan datos obligatorios"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Falten dades obligatòries"
		}
	},
	"16": {
		"categoria": 'medium',
		"es": {
			"titulo": "Alta rechazada",
			"cuerpo": "Ya hay un usuario registrado con el email indicado. En caso de no recordar tu usuario o tener cualquier problema, por favor contacta con nosotros."
		},
		"ca": {
			"titulo": "Alta rebutjada",
			"cuerpo": "Ja hi ha un usuari registrat amb l'adreça electrònica indicada Si no us recordau de l'usuari o teniu cap problema, per favor, contactau amb nosaltres."
		}
	},
	"17": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede inscribirse a la oferta porque se solapa con su práctica"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No us podeu inscriure a l'oferta perquè se solapa amb la pràctica"
		}
	},
	"18": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede inscribirse a la oferta, es para estudiantes de grado"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No us podeu inscriure a l'oferta,  perquè és per a estudiants de grau"
		}
	},
	"19": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede inscribirse a la oferta, es para estudiantes de postgrado"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No us podeu inscriure a l'oferta, perquè és per a estudiants de postgrau"
		}
	},
	"20": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No tiene servicio de empleo"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No té servei d'ocupació"
		}
	},
	"21": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No tiene servicio de prácticas"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No té servei de pràctiques"
		}
	},
	"22": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No está identificado como UTP ni como UTE"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No estau identificat com a UTP ni com a UTE"
		}
	},
	"23": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No apareces matriculado de prácticas ponte en contacto con nosotros para solucionarlo"
		},
		"es": {
			"titulo": "Error",
			"cuerpo": "No apareixeu com a matriculat de pràctiques Posau-vos en contacte amb nosaltres per solucionar-ho"
		}
	},
	"24": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Hay un problema con su empresa. Póngase en contacto con el administrador"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Hi ha un problema amb la vostra empresa Posau-vos en contacte amb l'administrador"
		}
	},
	"25": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta ya tienen un gestor asociado y no puede editarse, póngase en contacto con él"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'oferta ja té un gestor associat i no es pot editar Posau-vos en contacte amb ell"
		}
	},
	"26": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se han encontrado estudios asociados a tu perfil. Por favor acude a secretaría de alumnos/as para actualizar tu información"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No hem trobat estudis associats al vostre perfil Per favor, anau a la secretaria d'alumnes per actualitzar la informació"
		}
	},
	"27": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Por favor revisa los Datos de la Práctica, la fecha de inicio debe ser anterior a la fecha de finalización de las prácticas."
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Per favor, revisau les dades de la pràctica: la data d'inici ha de ser anterior a la data de finalització."
		}
	},
	"28": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La contraseña no es segura, debe tener al menos 8 caracteres y un número."
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "La contrasenya no és segura, ha de tenir almenys 8 caràcters i un número"
		}
	},
	"29": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya hay un contacto registrado en la empresa con este email"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Ja hi ha un contacte registrat a l'empresa amb aquesta adreça electrònica"
		}
	},
	"30": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La candidatura ya ha sido tramitada, no puedes desinscribirte"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "La candidatura ja ha estat tramitada No us en podeu desinscriure"
		}
	},
	"31": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se encuentra la candidatura"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No trobam la candidatura"
		}
	},
	"32": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Lo sentimos, estás dado de baja del servicio y no puedes inscribirte a ofertas"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Ens sap greu, estàs donat de baixa del servei i No us podeu inscriure a ofertes"
		}
	},
	"33": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El cif no tiene formato correcto"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "El CIF no té el format correcte"
		}
	},
	"34": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El permiso de trabajo es obligatorio para usuarios con nacionalidad distinta a los 28 países de la Unión Europea"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "El permís de treball és obligatori per a usuaris amb nacionalitat diferent dels 28 països de la Unió Europea"
		}
	},
	"35": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "La encuesta no es accesible.",
			"to": '/'
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'enquesta no és accessible",
			"to": '/'
		}
	},
	"36": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La encuesta no es para usuarios existentes.",
			"to": '/'
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'enquesta no és per a usuaris existents",
			"to": '/'
		}
	},
	"37": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La encuesta no permite acceso anónimo. Intentan entrar como anonimo pero no se puede.",
			"to": '/'
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'enquesta no permet accés anònim Hi intentau entrar com a anònim però no podeu fer-ho",
			"to": '/'
		}
	},
	"38": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Atención. La encuesta a la que estás tratando de acceder ya no está disponible para tu perfil. No estas en el target de la encuesta.",
			"to": '/'
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Atenció L'enquesta a la qual intentau accedir ja no està disponible per al vostre perfil No sou al públic objectiu de l'enquesta",
			"to": '/'
		}
		

	},
	"39": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya has contestado esta encuesta",
			"to": '/'
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Ja heu contestat aquesta enquesta",
			"to": '/'
		}
	},
	"40": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Faltan preguntas por contestar"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Falten preguntes per contestar"
		}
	},
	"41": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se encuentran los estudios de la titulación indicada"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No trobam els estudis de la titulació indicada"
		}
	},
	"42": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El enlace está caducado o ya ha sido utilizado"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'enllaç està caducat o ja l'han fet servir"
		}
	},
	"43": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Atención",
			"cuerpo": "La contraseña se estableció anteriormente"
		},
		"ca": {
			"titulo": "Atención",
			"cuerpo": "La contrasenya es va establir anteriorment"
		}
	},
	"44": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El email indicado pertenece a otra empresa, indique otro."
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'adreça electrònica indicada pertany a una altra empresa Indicau-ne una altra"
		}
	},
	"45": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se encuentra al estudiante de prácticas indicado"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'extensió de l'arxiu no està permesa"
		}
	},
	"46": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La extensión del archivo no esta permitida"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'extensió de l'arxiu no està permesa"
		}
	},
	"47": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a otra titulación"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'oferta s'adreça a una altra titulació"
		}
	},
	"48": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "La candidatura no puede actualizarse porque no hay autorización para hacer prácticas."
		}
	},
	"49": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede cambiar el estado"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No podeu canviar l'estat"
		}
	},
	"52": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No tienes superados los créditos necesarios para inscribirte a la oferta"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No teniu superats els crèdits necessaris per inscriure-us a l'oferta"
		}
	},
	"53": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a estudiantes sin prácticas pendientes"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'oferta s'adreça a estudiants sense pràctiques pendents"
		}
	},
	"54": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Para poder ser /a a la oferta, se necesita estar en búsqueda activa. Para activarlo dirígete a Mi CV -> Datos de interés"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Per poder ser a l'oferta, cal estar en cerca activa Per activar-ho, anau a El meu CV -> Dades d'interès"
		}
	},
	"55": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Es necesario tener subido el CV propio para realizar la operación"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Cal tenir pujat el CV propi per fer l'operació"
		}
	},
	"56": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya tienes subido este documento, si quieres actualizarlo, elimínalo y vuélvelo a adjuntar."
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Ja heu pujat aquest document Si el voleu actualitzar, eliminau-lo i tornau-lo a adjuntar"
		}
	},
	"57": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Es necesario tener al menos una formación para realizar la operación"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Cal tenir almenys una formació per fer l'operació"
		}
	},
	"58": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La dedicación debe ser la misma que la marcada en el programa 80%. Los meses deben ser los marcados en el programa 12 meses."
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "La dedicació ha de ser la mateixa que la marcada al programa 80% Els mesos han de ser els marcats al programa 12 mesos"
		}
	},
	"59": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Tu usuario no tiene acceso al portal en estos momentos. Por favor, contacta con nosotros ante cualquier duda."
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "El vostre usuari no té accés al portal en aquests moments Per favor, contactau amb nosaltres per qualsevol dubte"
		}
	},
	"60": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El email ya esta registrado."
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'adreça electrònica ja està registrada"
		}
	},
	"62": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puedes eliminar todos los estudios"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No podeu eliminar tots els estudis"
		}
	},
	"63": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Programa de prácticas no encontrado"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Programa de pràctiques no trobat"
		}
	},
	"64": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya se ha solicitado la adhesión anteriormente"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Ja heu sol·licitat l'adhesió anteriorment"
		}
	},
	"65": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Este programa no necesita adhesión"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Aquest programa no necessita adhesió"
		}
	},
	"66": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El Documento de Identidad no tiene formato válido"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "El document d'identitat no té format vàlid"
		}
	},
	"68": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta no es editable"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'oferta no és editable"
		}
	},
	"69": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El email no tiene un formato válido"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'adreça electrònica no té un format vàlid"
		}
	},
	"70": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El teléfono no tiene un formato válido"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "El telèfon no té un format vàlid"
		}
	},
	"71": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Su usuario no tiene permisos de acceso. Por favor contacte con nosotros en caso de duda"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "El vostre usuari no té permisos d'accés Per favor, contactau amb nosaltres en cas de dubte"
		}
	},
	"72": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "Debes añadir el IBAN en tu perfil de empresa",
			"to": '/mi-empresa',
			"blank": true
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Heu d'afegir l'IBAN al perfil d'empresa",
			"to": '/la-meva-empresa',
			"blank": true
		},
	},
	"73": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El IBAN es incorrecto"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'IBAN és incorrecte"
		}
	},
	"74": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Evento no disponible"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Esdeveniment no disponible"
		}
	},
	"75": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Este evento no admite inscritos"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Aquest esdeveniment no admet inscrits"
		}
	},
	"76": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya estas inscrito al evento"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Ja estau inscrit a l'esdeveniment"
		}
	},
	"77": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El evento es para estudiantes"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'esdeveniment és per a estudiants"
		}
	},
	"78": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El evento es para egresados"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'esdeveniment és per a egressats"
		}
	},
	"79" : {
		"categoria": 'secondary',
		"es": {
			"titulo": "Atención",
			"cuerpo": "El usuario con el que está tratando de ingresar no tiene permisos de acceso. En caso de duda puede contactar con <a href='mailto:c.profesionales@ufv.es'>c.profesionales@ufv.es</a>",
			"to": '/login'
		},
		"ca": {
			"titulo": "Atenció",
			"cuerpo": "L'usuari indicat no te accés al Portal Contactau amb nosaltres en cas de dubte"
		}
	},
	"80" : {
		"categoria": 'secondary',
		"es": {
			"titulo": "Atención",
			"cuerpo": "No cumples los requisitos para inscribirte a la oferta"
		},
		"ca": {
			"titulo": "Atenció",
			"cuerpo": "No compliu els requisits per inscriure-us a l'oferta"
		}
	},
	"81" : {
		"categoria": 'secondary',
		"es": {
			"titulo": "Atención",
			"cuerpo": "Se ha alcanzado el límite de solicitudes de centro"
		},
		"ca": {
			"titulo": "Atención",
			"cuerpo": "Heu arribat al límit de sol·licituds de centre"
		}
	},
	"83": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El número de la Seguridad Social no es válido"
		}
	},
	"84": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede modificar el NAF"
		}
	},
	"90": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Acceso denegado",
			"cuerpo" : "Usuario bloqueado"
		},
		"ca" : {
			"titulo" : "Accés denegat",
			"cuerpo" : "Usuari blocat"
		}
	},
	"91": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Accés denegat",
			"cuerpo" : "No puede inscribirse a la oferta, sólo para alumnos adheridos y aceptados."
		},
		"ca" : {
			"titulo" : "Acceso denegado",
			"cuerpo" : "No us podeu inscriure a l'oferta, perquè només és per a alumnes adherits i acceptats"
		}
	},
	"94": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "El DNI que has indicado ya está dado de alta. Para acceder utiliza tu usuario y contraseña. Si no recuerdas tu contraseña puedes recuperarla mediante el enlace He olvidado mi contraseña.",
			"to": '/'
		},
		"ca" : {
			"titulo" : "Atención",
			"cuerpo" : "El DNI que heu indicat ja està donat d'alta. Per accedir-hi utilitza el teu usuari i contrasenya. Si no recordes la teva contrasenya, pots recuperar-la mitjançant l'enllaç He oblidat la meva contrasenya.",
			"to": '/'
		}
	},
	"95": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "Según nuestros registros, eres egresado/a de UIB. Para registrarte o logarte debes acceder con tu usuario de UIB Digital.<br>En caso de duda o de necesitar recuperar tus credenciales de UIB Digital, puedes hacerlo <a target='_blank' href='https://sso.uib.es/cas/login'>aquí</a>.",
			"to": '/'
		},
		"ca" : {
			"titulo" : "Atención",
			"cuerpo" : "Segons els nostres registres, ets egressat/da de UIB. Per registrar-te o llogar-te has d'accedir amb el teu usuari d'UIB Digital.<br>En cas de dubte o de necessitar recuperar les teves credencials d'UIB Digital, pots fer-ho <a target='_blank' href='https://sso.uib.es/cas/login'>aquí</a>.",
			"to": '/'
		}
	},
	"94": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "El DNI que has indicado ya está dado de alta. Para acceder utiliza tu usuario y contraseña. Si no recuerdas tu contraseña puedes recuperarla mediante el enlace He olvidado mi contraseña.",
			"to": '/'
		}
	},
	"95": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "Según nuestros registros, eres egresado/a de UIB. Para registrarte o logarte debes acceder con tu usuario de UIB Digital.<br>En caso de duda o de necesitar recuperar tus credenciales de UIB Digital, puedes hacerlo <a target='_blank' href='https://sso.uib.es/cas/login'>aquí</a>.",
			"to": '/'
		}
	},
	"108": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Atención",
			"cuerpo": "Las ofertas de prácticas no remuneradas deben darse de alta con, al menos, 10 días de antelación, modifica la fecha de inicio para poder crear la oferta."
		},
		"ca": {
			"titulo": "Atención",
			"cuerpo": "Las ofertas de prácticas no remuneradas deben darse de alta con, al menos, 10 días de antelación, modifica la fecha de inicio para poder crear la oferta."
		}
	},
	"109": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Atención",
			"cuerpo": "Las propuestas de prácticas no remuneradas deben darse de alta con, al menos, 10 días de antelación, modifica la fecha de inicio para poder crear la propuesta."
		},
		"ca": {
			"titulo": "Atención",
			"cuerpo": "Las propuestas de prácticas no remuneradas deben darse de alta con, al menos, 10 días de antelación, modifica la fecha de inicio para poder crear la propuesta."
		}
	},
	"111": {
		"categoria": 'medium',
		"es": {
			"titulo": "Atención",
			"cuerpo": "No puede inscribirse a la oferta porque no está autorizado para hacer prácticas."
		}
	},
	"113": {
		"categoria": 'medium',
		"es": {
			"titulo": "Atención",
			"cuerpo": "No puede inscribirse a la oferta porque es para alumnos con Beca B1."
		}
	},
	"114": {
		"categoria": 'secondary',
	},
	"115": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Lo sentimos! El NAF de su perfil no puede editarse porque ya cuenta con afiliaciones en la Seguridad Social, por favor contacta con <a href='mailto:c.profesionales@ufv.es' target='blank'>c.profesionales@ufv.es</a> en caso de duda."
		}
	},
	"500": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "El servicio actualmente no esta disponible"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "El servei actualment no està disponible"
		}
	},
	"501": {
		"categoria": 'secondary',
		"es": {
			"titulo": "¡Enhorabuena!",
			"cuerpo": "Te has desinscrito correctamente"
		},
		"ca": {
			"titulo": "Enhorabona!",
			"cuerpo": "Us heu desinscrit correctament"
		}
	},
	"502": {
		"categoria": 'secondary',
		"es": {
			"titulo": "¡Atención!",
			"cuerpo": 'La empresa recibirá tu currículum generado a partir de los datos que has consignado en el menú "Mi perfil". Aségúrate de tenerlo siempre actualizado y lo más completo posible, incluyendo una copia de tu CV personal'
		},
		"ca": {
			"titulo": "Atenció!",
			"cuerpo": "L'empresa rebrà el vostre currículum generat a partir de les dades que heu consignat al menú 'Mi perfil'. Aségúrate de tenerlo siempre actualizado y lo más completo posible, incluyendo una copia de tu CV personal"
		}
	},
	"503": {
		"categoria": 'important',
		"es": {
			"titulo": "Te has registrado correctamente",
			"cuerpo": "La empresa ha sido dada de alta correctamente. Validaremos los datos facilitados y te enviaremos un mail confirmando tu registro en el menor tiempo posible.",
			"to": '/login/empresas'
		},
		"ca": {
			"titulo": "Us heu registrat correctament",
			"cuerpo": "L'empresa ha estat donada d'alta correctament Validarem les dades facilitades i us enviarem un correu al més aviat possible per confirmar-vos el registre",
			"to": '/login/empreses'
		}
	},
	"120": {
		"categoria": 'important',
		"es": {
			"titulo": "Te has registrado correctamente",
			"cuerpo": "La empresa ha sido dada de alta correctamente  y está pendiente de creación en el foro activo. Validaremos los datos facilitados y te enviaremos un mail confirmando tu registro en el menor tiempo posible.",
			"to": '/login/empresas'
		},
		"ca": {
			"titulo": "Us heu registrat correctament",
			"cuerpo": "L'empresa ha estat donada d'alta correctament Validarem les dades facilitades i us enviarem un correu al més aviat possible per confirmar-vos el registre",
			"to": '/login/empreses'
		}
	},
	"504": {
		"categoria": 'important',
		"es": {
			"titulo": "Te has registrado correctamente",
			"cuerpo": "Utiliza tu email y la contraseña registrados para logarte en el portal.",
			"to": '/login/empresas'
		},
		"ca": {
			"titulo": "Us heu registrat correctament",
			"cuerpo": "Fes servir l'adreça electrònica i la contrasenya registrades per entrar al portal",
			"to": '/login/empreses'
		}
	},
	"505": {
		"categoria": 'medium',
		"es": {
			"titulo": "",
			"cuerpo": "Te hemos enviado un enlace de recuperación a tu email."
		},
		"ca": {
			"titulo": "",
			"cuerpo": "Us hem enviat un enllaç de recuperació a l'adreça electrònica"
		}
	},
	"506": {
		"categoria": 'medium',
		"es": {
			"titulo": "¡Muchas gracias!",
			"cuerpo": "Tu oferta ha sido creada correctamente. Te enviaremos un mail avisándote de su activación.",
			"to": '/mis-ofertas'
		},
		"ca": {
			"titulo": "Moltes gràcies!",
			"cuerpo": "L'oferta ha estat creada correctament Us enviarem un correu electrònic per avisar-vos que està activada",
			"to": '/les-meves-ofertes'
		}
	},
	
	"507": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "La descripción de la empresa ha sido guardada"
		},
		"ca": {
			"titulo": "Enhorabona",
			"cuerpo": "La descripció de l'empresa ha estat desada"
		}
	},
	"508": {
		"categoria": 'important',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Tu contraseña ha sido restablecida"
		},
		"ca": {
			"titulo": "Enhorabona",
			"cuerpo": "La contrasenya ha estat restablerta"
		}
	},
	"509": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se ha encontrado ningún candidato/a con ese DNI."
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "No hem trobat cap candidat amb aquest DNI"
		}
	},
	"510": {
		"categoria": 'medium',
		"es": {
			"titulo": "Propuesta de prácticas registrada correctamente",
			"cuerpo": "Tu solicitud ha sido dada de alta correctamente. Revisaremos los datos aportados y te enviaremos un email informándote sobre su validación o rechazo en el menor tiempo posible.",
			"to": '/'
		},
		"ca": {
			"titulo": "Proposta de pràctiques registrada correctament",
			"cuerpo": "La vostra sol·licitud ha estat donada d'alta correctament Revisarem les dades aportades i us enviarem un correu per informar-vos de la seva validació o rebuig al més aviat possible",
			"to": '/'
		}
	},
	"511": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "La oferta ha sido cerrada correctamente",
			"to": "/mis-ofertas"
		},
		"ca": {
			"titulo": "Enhorabona",
			"cuerpo": "L'oferta ha estat tancada correctament",
			"to": "/les-meves-ofertes"
		}
	},
	"512": {
		"categoria": 'medium',
		"es": {
			"titulo": "¡Muchas gracias!",
			"cuerpo": "Tu oferta ha sido modificada correctamente. Recuerda que solo puedes modificar los detalles de tus ofertas mientras estén “pendiente” de validar y no caducadas",
			"to": '/mis-ofertas'
		},
		"ca": {
			"titulo": "Moltes gràcies!",
			"cuerpo": "L'oferta ha estat modificada correctament Recordau que només podeu modificar els detalls de les ofertes mentre estiguin «pendents» de validar i no caducades",
			"to": '/les-meves-ofertes'
		}
	},
	"513": {
		"categoria": 'medium',
		"es": {
			"titulo": "¡Enhorabuena!",
			"cuerpo": "Tu documentación ha sido adjuntada correctamente",
		},
		"ca": {
			"titulo": "Enhorabona!",
			"cuerpo": "La documentació ha estat adjuntada correctament",
		}
	},
	"514": {
		"categoria": 'important',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Tu contraseña ha sido establecida"
		},
		"ca": {
			"titulo": "Enhorabona",
			"cuerpo": "La contrasenya ha estat restablerta"
		}
	},
	"515": {
		"categoria": 'medium',
		"es": {
			"titulo": "Atención",
			"cuerpo": "Mensaje del servidor"
		},
		"ca": {
			"titulo": "Atenció",
			"cuerpo": "Missatge del servidor"
		}
	},
	"516": {
		"categoria": 'medium',
		"es": {
			"titulo": "Oferta eliminada",
			"cuerpo": "Tu oferta ha sido eliminada correctamente",
			"to": '/mis-ofertas'
		},
		"ca": {
			"titulo": "Oferta eliminada",
			"cuerpo": "L'oferta ha estat eliminada correctament",
			"to": '/les-meves-ofertes'
		}
	},
	"517": {
		"categoria": 'medium',
		"es": {
			"titulo": "",
			"cuerpo": "Hemos recibido su solicitud. La tramitaremos e informaremos de la baja definitiva lo antes posible.",
		},
		"ca": {
			"titulo": "",
			"cuerpo": "Hem rebut la sol·licitud La tramitarem i us informarem de la baixa definitiva al més aviat possible",
		}
	},
	"518": {
		"categoria": 'medium',
		"es": {
			"titulo": "Atención",
			"cuerpo": "Por favor, completa los datos de número de cuenta y número de Seguridad Social para poder seguir accediendo al portal.",
		},
		"ca": {
			"titulo": "Atenció",
			"cuerpo": "Per favor, completau les dades de número de compte i número de Seguretat Social per poder continuar accedint al portal",
		}
	},
	"519": {
		"categoria": 'medium',
		"es": {
			"titulo": "",
			"cuerpo": "Tu respuesta a la preinscripción ha sido registrada correctamente",
		},
		"ca": {
			"titulo": "",
			"cuerpo": "La resposta a la preinscripció ha estat registrada correctament",
		}
	},
	"520": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Has rechazado tu inscripción correctamente",
		},
		"ca": {
			"titulo": "Enhorabuena",
			"cuerpo": "Heu rebutjat la inscripció correctament",
		}
	},
	"521": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Tu contraseña ha sido cambiada correctamente",
		},
		"ca": {
			"titulo": "Enhorabuena",
			"cuerpo": "La contrasenya ha estat canviada correctament",
		}
	},
	"522": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Enhorabuena, tu usuario ha sido creado correctamente. Competa tu perfil para acceder todas las ofertas y servicios.",
		},
		"ca": {
			"titulo": "Enhorabona",
			"cuerpo": "Enhorabona, el vostre usuari ha estat creat correctament Completau el perfil per accedir a totes les ofertes i serveis",
		}
	},
	"523": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Has solicitado la adhesión al programa correctamente.",
		},
		"ca": {
			"titulo": "Enhorabona",
			"cuerpo": "Heu sol·licitat l'adhesió al programa correctament",
		}
	},
	"524": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El email indicado no pertenece a ningún usuario activo de la aplicación. Contacta con nosotros en caso de duda",
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "L'adreça electrònica indicada no pertany a cap usuari actiu de l'aplicació Contactau amb nosaltres en cas de dubte",
		}
	},
	"525": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Por favor revisa todos los campos"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Per favor, revisau tots els camps"
		}
	},
	"526": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Por favor sube una foto de maximo (1000px)"
		},
		"ca": {
			"titulo": "Error",
			"cuerpo": "Per favor, pujau una foto de màxim (1000px)"
		}
	},
	"527": {
		"categoria": 'medium',
		"es": {
			"titulo": "¡Atención!",
			"cuerpo": "El candidato/a no quedará seleccionado si no cumplimentas todos los datos obligatorios de este formulario de selección, que son necesarios para la formalización de prácticas."
		},
		"ca": {
			"titulo": "Atenció!",
			"cuerpo": "El candidat no quedarà seleccionat si no emplenau totes les dades obligatòries d'aquest formulari de selecció, que són necessàries per a la formalització de pràctiques"
		}
	},
	"528": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Su solicitud ha sido dada de alta correctamente. Revisaremos los datos aportados y le informaremos sobre su validación o rechazo en el menor tiempo posible. Si no tiene formalizado un convenio de colaboración educativa. Por favor, solicítelo.",
			"to": '/'
		},
		"ca": {
			"titulo": "Enhorabona",
			"cuerpo": "La vostra sol·licitud ha estat donada d'alta correctament Revisarem les dades aportades i us informarem sobre la seva validació o rebuig al més aviat possible Si no teniu formalitzat un conveni de col·laboració educativa, per favor, sol·licitau-lo"
		}
	},
	"529": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enviado",
			"cuerpo": "Gracias por tu solicitud, gestionaremos el cambio solicitado a la mayor brevedad posible.",
			"to": '/'
		},
		"ca": {
			"titulo": "Enviat",
			"cuerpo": "Gràcies per la sol·licitud Gestionarem el canvi sol·licitat al més aviat possible",
			"to": '/'
		}
	},

	"530": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Enviado",
			"cuerpo" : "Solicitud rechazada correctamente",
		},
		"ca" : {
			"titulo" : "Enviat",
			"cuerpo" : "Sol·licitud rebutjada correctament",
		}
	},
	"531": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Enviado",
			"cuerpo" : "Solicitud aceptada correctamente",
		},
		"ca" : {
			"titulo" : "Enviat",
			"cuerpo" : "Sol·licitud acceptada correctament",
		}
	},
	"532": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Enviado",
			"cuerpo" : "Información actualizada correctamente",
		},
		"ca" : {
			"titulo" : "Enviat",
			"cuerpo" : "Informació actualitzada correctament",
		}
	},
	"533": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Has solicitado la adhesión al programa correctamente",
		},
		"ca": {
			"titulo": "Enhorabona",
			"cuerpo": "Heu sol·licitat l'adhesió al programa correctament",
		}
	},
	"534": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "Cuando registremos tu solicitud, se hará con los datos generados a partir de tu perfil, por favor, completa y/o actualiza el mismo lo más detalladamente posible, incluyendo las notas medias de tus titulaciones oficiales.",
			"to" : '/cv',
			"btn_text" : "Ir a mi CV"
		},
		"ca" : {
			"titulo" : "Atenció",
			"cuerpo" : "Quan registrem la sol·licitud, es farà amb les dades generades a partir del perfil Per favor, completau-lo i/o actualitzau-lo amb el màxim de detall possible, incloent-hi les notes mitjanes de les vostres titulacions oficials",
			"to" : '/ca/cv',
			"btn_text" : "Anar al meu CV"
		}
	},
	"535": {
		"categoria": 'important',
		"es": {
			"titulo": "¡Atención!",
			"cuerpo": "Debes cumplimentar el dato Número cuenta IBAN en menú Mi Empresa antes de crear una oferta de prácticas. ",
			"to" : '/mi-empresa',
			"btn_text" : "Cumplimentar ahora"
		},
		"ca": {
			"titulo": "Atenció!",
			"cuerpo": "Heu d'emplenar la dada Número compte IBAN al menú La meva empresa abans de crear una oferta de pràctiques",
			"to" : '/la-meva-empresa',
			"btn_text" : "Emplenar-lo ara"
		}
	},
	"536": {
		"categoria": 'medium',
		"es": {
			"titulo": "Muchas gracias",
			"cuerpo": "Convenio añadido correctamente",
			"to": "/"
		},
		"ca": {
			"titulo": "Moltes gràcies",
			"cuerpo": "Contacte afegit correctament",
			"to": "/"
		}
	},
	"536": {
		"categoria": 'medium',
		"es": {
			"titulo": "Muchas gracias",
			"cuerpo": "Convenio añadido correctamente",
			"to": "/"
		},
		"ca": {
			"titulo": "Moltes gràcies",
			"cuerpo": "Contacte afegit correctament",
			"to": "/"
		}
	},
	"537": {
		"categoria": 'medium',
		"es": {
			"titulo": "¡Atención!",
			"cuerpo": "Para poder validar tu registro debes incluir una copia de tu título en la sección 'Documentación privada' del menú 'Mi CV'",
		}
	},
	"538": {
		"categoria": 'medium',
		"es": {
			"titulo": "",
			"cuerpo": "Enhorabuena, contacto creado correctamente. Ya lo tiene disponible en el listado de contactos disponibles.",
		},
		"ca": {
			"titulo": "",
			"cuerpo": "Contacte afegit correctament",
		}
	},
	"539": {
		"categoria": 'medium',
		"es": {
			"titulo": "¡Muchas gracias!",
			"cuerpo": "Tu solicitud ha sido registrada,<br> en breve nos pondremos en contacto contigo.",
			"to": '/'
		}
	},
	"540": {
		"categoria": 'important',
		"es": {
			"titulo": "¡Enhorabuena!",
			"cuerpo": "Has rellenado el formulario de incorporación y el candidato ha pasado a seleccionado.",
			"to": '/'
		}
	},
	"541": {
		"categoria": 'important',
		"es": {
			"titulo": "Muchas gracias",
			"cuerpo": "Has rellenado el formulario de contacto correctamente, en breve nos pondremos en contacto contigo.",
			"to": '/'
		}
	},
	
	"543": {
		"categoria": 'medium',
		"es": {
			"titulo": "¡Atención!",
			"cuerpo": "No se puede cambiar el estado de una candidatura en una oferta caducada."
		}
	},
	"custom": {
		"categoria": 'medium',
		"es": {
			"titulo": "",
			"cuerpo": ""
		},
		"ca": {
			"titulo": "",
			"cuerpo": ""
		}
	},
	"544": {
		"categoria": 'medium',
		"es": {
			"titulo": "Atención",
			"cuerpo": "Su empresa no tiene <strong>Convenio de Colaboración firmado y activo</strong> con la universidad. Para poder tramitar su propuesta de prácticas debe cumplimentar el formulario de solicitud de convenio pinchando a continuación​.",
			"to": '/nuevo-convenio-colaboracion',
			"btn_text" : "SOLICITAR CONVENIO "
		}
	},
	"618": {
		"categoria": 'medium',
		"es": {
			"titulo": "",
			"cuerpo": "El documento se ha guardado correctamente.",
		},
	},
	"619": {
		"categoria": 'medium',
		"es": {
			"titulo": "¡Enhorabuena!",
			"cuerpo": "Te has inscrito correctamente al evento."
		},
		"ca": {
			"titulo": "¡Enhorabuena!",
			"cuerpo": "Te has inscrito correctamente al evento."
		}
	},
}



// WEBPACK FOOTER //
// ./src/errors/index.js